export const GET_USER_STATISTIC_DATA_BY_ID_REQUEST =
  'GET_USER_STATISTIC_DATA_BY_ID_REQUEST';
export const GET_USER_STATISTIC_DATA_BY_ID_SUCCESS =
  'GET_USER_STATISTIC_DATA_BY_ID_SUCCESS';
export const GET_USER_STATISTIC_DATA_BY_ID_FAILED =
  'GET_USER_STATISTIC_DATA_BY_ID_FAILED';
export const GET_USER_STATISTIC_DATA_BY_ID_CLEAR =
  'GET_USER_STATISTIC_DATA_BY_ID_CLEAR';

export const GET_LOGGED_USER_STATISTIC_DATA_REQUEST =
  'GET_LOGGED_USER_STATISTIC_DATA_REQUEST';
export const GET_LOGGED_USER_STATISTIC_DATA_SUCCESS =
  'GET_LOGGED_USER_STATISTIC_DATA_SUCCESS';
export const GET_LOGGED_USER_STATISTIC_DATA_FAILED =
  'GET_LOGGED_USER_STATISTIC_DATA_FAILED';
export const GET_LOGGED_USER_STATISTIC_DATA_CLEAR =
  'GET_LOGGED_USER_STATISTIC_DATA_CLEAR';

export const GET_ALL_USERS_STATISTIC_DATA_REQUEST =
  'GET_ALL_USERS_STATISTIC_DATA_REQUEST';
export const GET_ALL_USERS_STATISTIC_DATA_SUCCESS =
  'GET_ALL_USERS_STATISTIC_DATA_SUCCESS';
export const GET_ALL_USERS_STATISTIC_DATA_FAILED =
  'GET_ALL_USERS_STATISTIC_DATA_FAILED';
export const GET_ALL_USERS_STATISTIC_DATA_CLEAR =
  'GET_ALL_USERS_STATISTIC_DATA_CLEAR';
